import React from "react";
import PropTypes from "prop-types";

import Title from "./Title";
import Description from "./Description";

import Box from "@mui/material/Box";

const Content = ({ type, content, settings, link_title }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Title type={type} />
      <Description
        type={type}
        content={content}
        settings={settings}
        link_title={link_title}
      />
    </Box>
  );
};

Content.propTypes = {
  type: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  settings: PropTypes.object.isRequired,
  link_title: PropTypes.string.isRequired,
};

export default Content;
